import React from 'react'
import { useEffectOnce } from 'react-use'

import useTemplateId from '../../../hooks/useTemplateId'
import BottomShade from 'components/BottomShade'
import ConfiguratorActionButtons from 'components/ConfiguratorActionButtons'
import SlideInWrapper from 'components/SlideInWrapper'
import UnsavedChangesModal from 'components/UnsavedChangesModal'
import SupportForm from 'components/forms/SupportForm'
import { useFormState } from 'hooks/useFormState'
import useSectionOpenedTracking from 'hooks/useSectionOpenedTracking'
import { useUnsavedChangesModal } from 'hooks/useUnsavedChangesModal'
import { scrollToPreviewTop } from 'lib/helpers'

function Contact() {
	const formId = 'contact'
	const formRef = React.useRef<HTMLFormElement>(null)
	const [state, handlers] = useFormState()
	const { hideModal, handleDiscardChanges } = useUnsavedChangesModal(formRef, state.isDirty)
	const { templateId } = useTemplateId()
	useEffectOnce(scrollToPreviewTop)
	useSectionOpenedTracking()

	return (
		<>
			<UnsavedChangesModal onDiscardChanges={handleDiscardChanges} onStayHere={hideModal} name="Contact card" />
			<SlideInWrapper>
				<SupportForm key={templateId} id={formId} {...handlers} ref={formRef} />
			</SlideInWrapper>
			<BottomShade />
			<ConfiguratorActionButtons formId={formId} {...state} />
		</>
	)
}

export default Contact
